import { Fragment } from "react";

export const CategoryHtmlBlog = ({ html }) => {
  return (
    <Fragment>
      {html && (
        <div className="row">
          <div className="brand-content my-3">
            <div dangerouslySetInnerHTML={{ __html: html }} />
          </div>
        </div>
      )}
    </Fragment>
  );
};
